// --- React ---
import React, { useEffect, useState } from 'react';

// --- 스타일 · 테마 ---
import { useTheme } from '@/theme';

// --- 유틸 ---
import { formatDateTime, getBrowserTimezone, getTimezoneInfo } from '@/utils/date';

/**
 * 현재 시각 + 브라우저 타임존을 실시간으로 표시하는 인디케이터.
 *
 * 로그/테이블의 시각이 "사용자 브라우저 타임존" 기준으로 올바르게 변환됐는지
 * 눈으로 대조하기 위한 기준선 역할을 한다. 표시 값은 항상 브라우저 tz 기준이다.
 */
export const CurrentTimeIndicator: React.FC = () => {
  const { theme } = useTheme();
  const [now, setNow] = useState<Date>(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const tz = getBrowserTimezone();
  const { offset } = getTimezoneInfo();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: theme.spacing[2],
        whiteSpace: 'nowrap',
        color: theme.colors.text.secondary,
        fontSize: theme.fontSize.xs,
      }}
      title={`${tz} (UTC${offset})`}
    >
      <span
        style={{
          fontVariantNumeric: 'tabular-nums',
          fontWeight: 600,
          color: theme.colors.text.primary,
        }}
      >
        {formatDateTime(now)}
      </span>
      <span>
        {tz} · UTC{offset}
      </span>
    </div>
  );
};
